<!--
  - This file is part of the Web3 Library developed by mFactory GmbH.
  -
  - Copyright © 2021, mFactory GmbH
  -
  - Solana Reference Stake Pool is free software: you can redistribute it
  - and/or modify it under the terms of the GNU Affero General Public License
  - as published by the Free Software Foundation, either version 3
  - of the License, or (at your option) any later version.
  -
  - Solana Reference Stake Pool is distributed in the hope that it
  - will be useful, but WITHOUT ANY WARRANTY; without even the implied
  - warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
  - See the GNU Affero General Public License for more details.
  -
  - You should have received a copy of the GNU Affero General Public License
  - along with this program.
  - If not, see <https://www.gnu.org/licenses/agpl-3.0.html>.
  -
  - You can be released from the requirements of the Affero GNU General Public License
  - by purchasing a commercial license. The purchase of such a license is
  - mandatory as soon as you develop commercial activities using the
  - Solana Reference Stake Pool code without disclosing the source code of
  - your own applications.
  -
  - The developer of this program can be contacted at <info@mfactory.ch>.
  -->

<script setup lang="ts">
import { TELEGRAM_URL } from '~/config'

const date = new Date().getFullYear()
</script>

<template>
  <q-footer :class="$style.footer">
    <div class="container">
      <div class="row justify-between items-center q-mb-xs">
        <div
          class="justify-start d-flex column"
          :class="{
            'order-last q-mx-auto q-mt-xs': $q.screen.lt.md,
            'q-mr-auto': $q.screen.gt.sm,
          }"
        >
          <div class="text-left">
            © Copyright {{ date }} Staking Kiwi Validator. All rights reserved.
          </div>
          <div class="text-left">
            Powered by
            <a href="https://staking.kiwi" target="_blank">staking.kiwi</a>
          </div>
        </div>
        <div class="justify-between d-flex column">
          <div class="row" :class="{ 'q-mx-auto': $q.screen.lt.sm }">
            <!-- <div v-if="$q.screen.lt.md" class="row items-center justify-end q-mb-xs">
              <theme-mode-selector />
            </div> -->
            <div :class="$style.buttons">
              <div :class="$style.links" />

              <q-btn
                :href="TELEGRAM_URL"
                color="white"
                class="q-ml-md"
                round
                target="_blank"
                type="a"
                unelevated
              >
                <telegram-svg class="q-icon" />
              </q-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </q-footer>
</template>

<style lang="scss" module>
.footer {
  background-color: $blue-grey-8 !important;
  color: #fff !important;
  padding: 6px 0 4px;
  font-size: 12px;

  @media (max-width: $breakpoint-sm) {
    text-align: center;
  }

  a {
    color: #fff;
    text-decoration: underline;
  }
}

.nav {
  justify-content: center;
  text-align: center;

  a {
    margin: 0 0.5em;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
}

.buttons {
  text-align: right;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 4px 0 4px 8px;

  a {
    color: $blue-grey-8 !important;
    font-size: 14px;
  }

  @media (max-width: $breakpoint-sm) {
    justify-content: center;
  }
}

.links {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-right: 1rem;
  line-height: 1;

  a {
    border-right: 1px solid rgba(#fff, 0.5);
    padding: 0 8px;
    font-size: 0.8rem !important;
    color: #fff !important;

    &:hover {
      text-decoration: none;
    }

    &:last-child {
      border: 0;
    }
  }

  @media (max-width: $breakpoint-sm) {
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 8px;

    a {
      margin: 5px 0;
      display: inline-block;
    }
  }
}
</style>

<style lang="scss" scoped>
.footer {
  &__kiwi-banner {
    height: 42px;
    display: flex;
    align-items: center;
    color: #fff !important;
    text-decoration: none;
    font-size: 10px;
    margin-left: 16px;
    text-align: left;

    img {
      margin-left: 8px;
      height: 42px;
    }
  }
}

// Dark mode

body.body--dark {
  .q-footer {
    border-top: 2px solid #f4f4f4 !important;
  }
}
</style>
